import { EventEmitter, Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { CommonService } from './common.service';

export class PathObject {
  name: string;
  id: string;

  constructor(name: string, id: string) {
    this.name = name;
    this.id = id;
  }
}

@Injectable()
export class PathService {
  currentPath = '';
  pathReloadEvent = new EventEmitter();

  constructor(private router: Router, private activatedRoute: ActivatedRoute, private commonService: CommonService) {}

  getPath(): any {
    const parentRoute: ActivatedRoute | null = this.router.routerState.root.firstChild;
    let childRoute: ActivatedRoute | null = null;
    if (parentRoute !== null) {
      childRoute = parentRoute.firstChild; // all files (value)
    }
    if (childRoute !== null) {
      if (childRoute.firstChild != null) {
        if (childRoute.firstChild.snapshot?.url.length > 0) this.currentPath = childRoute.firstChild.snapshot.url[0].path;
        else this.currentPath = '';
      }
    } else {
      this.currentPath = '';
    }

    return this.currentPath;
  }

  getCurrentPath(): string {
    return this.router.url;
  }

  canCreateFolderHere(): boolean {
    const parentRoute: ActivatedRoute | null = this.router.routerState.root.firstChild;
    const childRoute: ActivatedRoute | null = parentRoute && parentRoute.firstChild;
    if (childRoute && childRoute.snapshot.url[0]?.path) {
      this.commonService.isDetailClicked.next(false);
    }
    if (this.getCurrentPath() === '/paylasimlar' || this.getCurrentPath() === '/paylasimlar#iss=https://kullanici-safirdepo-suite-dev.b3lab.org/realms/SafirDepo') {
      localStorage.setItem('permission', 'VIEW');
    }
    if (
      this.getCurrentPath().includes('genel-bakis') ||
      this.getCurrentPath().includes('gruplarim') ||
      this.getCurrentPath().includes('cop-kutusu') ||
      this.getCurrentPath().includes('yakin-tarihli') ||
      this.getCurrentPath().includes('favorilerim') ||
      this.getCurrentPath().includes('versiyon-gecmisi') ||
      this.getCurrentPath().includes('profil-ayarlari') ||
      this.getCurrentPath().includes('guvenlik-ayarlari') ||
      this.getCurrentPath().includes('sifreli-depo-guncelleme')
    ) {
      localStorage.setItem('permission', 'VIEW');
    }

    if (
      this.getCurrentPath().includes('/sifreli-depo/liste') ||
      (this.getCurrentPath().includes('/depom') && !this.getCurrentPath().includes('versiyon-gecmisi')) ||
      localStorage.getItem('permission') === 'EDIT'
    ) {
      localStorage.setItem('permission', 'EDIT');

      return true;
    } else {
      return false;
    }
  }
}
